import React, {ButtonHTMLAttributes, DetailedHTMLProps} from 'react';
import Tag from "../Tag/Tag";
import {ITagCatalog} from "../../interfaces/categoryProducts.interface";
import {useAppSelector} from "../../store/store";

interface TagProps extends DetailedHTMLProps<ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement> {
    tag: ITagCatalog
    onClick?: () => void
    active: boolean
}


const CatalogTag = ({tag, onClick, active}:TagProps) => {
    return (
        <Tag onClick={onClick} tag={tag.name} active={active}/>
    );
};

export default CatalogTag;